import { render } from "./GuideGettingStarted.vue?vue&type=template&id=0e44432e&scoped=true"
import script from "./GuideGettingStarted.vue?vue&type=script&lang=js"
export * from "./GuideGettingStarted.vue?vue&type=script&lang=js"

import "./GuideGettingStarted.vue?vue&type=style&index=0&id=0e44432e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e44432e"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
